import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/package',
  component: Layout,
  name: 'packageManagement',
  meta: {
    title: '套餐卡管理',
    icon: 'i-ep:credit-card',
    menu: false,
  },
  children: [
    {
      path: 'list',
      name: 'packageList',
      component: () => import('@/views/package/index.vue'),
      meta: {
        title: '套餐卡列表',
        icon: 'i-ep:credit-card',
      },
    },
    {
      path: 'add',
      name: 'packageAdd',
      component: () => import('@/views/package/add.vue'),
      meta: {
        title: '新增套餐卡',
        icon: 'i-ep:plus',
        menu: false,
        activeMenu: '/package/list',
      },
    },
    {
      path: 'detail/:id',
      name: 'packageDetail',
      component: () => import('@/views/package/detail.vue'),
      meta: {
        title: '套餐详情',
        icon: 'i-ep:document',
        menu: false,
        activeMenu: '/package/list',
      },
    },
    {
      path: 'edit/:id',
      name: 'packageEdit',
      component: () => import('@/views/package/edit.vue'),
      meta: {
        title: '编辑套餐卡',
        icon: 'i-ep:edit',
        menu: false,
        activeMenu: '/package/list',
      },
    },
    {
      path: ':id/plan',
      name: 'productPlan',
      component: () => import('@/views/product/[id]/plan.vue'),
      meta: {
        title: '版本计划',
        icon: 'i-ep:calendar',
        menu: false,
        activeMenu: '/product/list',
      },
    },
    {
      path: ':id/plan/create',
      name: 'productPlanCreate',
      component: () => import('@/views/product/[id]/plan/form.vue'),
      meta: {
        title: '新增计划',
        icon: 'i-ep:plus',
        menu: false,
        activeMenu: '/product/list',
      },
    },
    {
      path: ':id/plan/edit/:planId',
      name: 'productPlanEdit',
      component: () => import('@/views/product/[id]/plan/form.vue'),
      meta: {
        title: '编辑计划',
        icon: 'i-ep:edit',
        menu: false,
        activeMenu: '/product/list',
      },
    },
  ],
}

export default routes
